import { NewMemberInfo } from '../../../auth/components/new-member/NewMemberInfo';

export default function NewMemberInfoPage() {
    return <NewMemberInfo />;
}
